import { Component, OnInit, Input, ChangeDetectorRef } from '@angular/core';
import { CountryManagementService } from '../../../service/country-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { ChargeMethod, KeyValues5, LocalService, NumericConfig, Status, ToolPricingInitialization } from '../../../service/local.service';

@Component({
  selector: 'app-tool-pricing-config',
  templateUrl: './tool-pricing-config.component.html',
  styleUrls: ['./tool-pricing-config.component.scss']
})
export class ToolPricingConfigComponent implements OnInit {
  ctryId = ''; @Input() isEditMode = false; lstSectionConfigKeys: string[] = ["tool_pricing"];
  source: ToolPricingInitialization; items: KeyValues5[]; maxBodyHeight = 0;
  numericConfig: NumericConfig = { isDecimalAllowed: true } as NumericConfig;
  ctryCode: string = '';

  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private countryManagementService: CountryManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    if (!this.isEditMode && !this.localService.countryCodes) {
      this.countryManagementService.getCountryCodesToDisplay().subscribe(result => {
        this.localService.countryCodes = result;
        this.onLoad();
      });
    } else {
      this.onLoad();
    }
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetMaxModalBodyHeight();
    this.cdr.detectChanges();
  }

  onSetCountryId() {
    if (this.ctryId == '') {
      let defacultCountry = this.localService.countryCodes.find(x => x.v2 == this.localService.selected.countryCode);
      this.ctryId = defacultCountry ? defacultCountry.key : this.localService.getCurrentTimeZoneCountryId();
    }
  }

  onLoad(isResetAll = false) {
    this.onSetCountryId();
    this.ctryCode = this.localService.getCountryCodeByCountryId(this.ctryId).toLowerCase();
    if (!this.source || isResetAll) {
      this.countryManagementService.getToolPricingInitialization(this.ctryId, this.isEditMode).subscribe(result => {
        this.source = result;
        this.onFormatPricing();
      });
    } else {
      this.countryManagementService.getCountryPricing(this.ctryId, this.isEditMode).subscribe(result => {
        this.source.items = result;
        this.onFormatPricing();
      });
    }
  }

  onFormatPricing() {
    this.items = [];
    this.source.chargeMethod.forEach(itemChargeMethod => {
      this.items.push({
        key: '-',
        v1: itemChargeMethod.key,
        v2: '',
        value: 1,
        isReadonly: true
      } as KeyValues5);
      let chargeMethod = parseInt(itemChargeMethod.key);
      switch (chargeMethod) {
        case ChargeMethod.ToolPricingType: {
          let itemsTemp: KeyValues5[] = [];
          this.source.toolPricingType.forEach(itemType => {
            let item = this.source.items.find(x => x.v1 == itemChargeMethod.key && x.v2 == itemType.key);
            itemsTemp.push({
              key: item ? item.key : '',
              v1: itemChargeMethod.key,
              v2: itemType.key,
              value: item ? parseFloat(item.v3) : null,
              isReadonly: item ? item.v4 == '1' : false
            } as KeyValues5);
          });
          this.items.push(...this.localService.Sort(itemsTemp, true, "v2"));
        } break;
        case ChargeMethod.NotificationType: {
          let itemsTemp: KeyValues5[] = [];
          this.source.notificationType.forEach(itemType => {
            let item = this.source.items.find(x => x.v1 == itemChargeMethod.key && x.v2 == itemType.key);
            itemsTemp.push({
              key: item ? item.key : '',
              v1: itemChargeMethod.key,
              v2: itemType.key,
              value: item ? parseFloat(item.v3) : null,
              isReadonly: item ? item.v4 == '1' : false
            } as KeyValues5);
          });
          this.items.push(...this.localService.Sort(itemsTemp, true, "v2"));
        } break;
      }
    });

    if (!this.isEditMode) {
      this.items = this.items.filter(x => x.value && x.value > 0);
    }
  }

  onSave() {
    this.items.forEach(item => {
      if (item.key != '-') {
        item.v3 = item.value ? item.value.toString() : '';
        item.v4 = item.isReadonly ? '1' : '0'
      }
    });
    this.countryManagementService.saveCountryPricing(this.ctryId, this.items.filter(x => x.key != '-')).subscribe(result => {
      if (result.filter(x => x.status == Status.Success).length > 0) {
        this.localService.showInformationByStatus(Status.Success);
      } else {
        this.localService.showInformationByStatus(Status.Failed);
      }
    });
  }
}
